import * as React from 'react';
import { Theme } from './types';

export type ThemeContextValue = {
  /**
   * Změna téma.
   * @param ns nové téma
   * @param className další případné class pro doplnění
   */
  change: (ns: string, className?: string) => void;
} & Theme;

export const ThemeContext = React.createContext<ThemeContextValue>({
  ns: '',
  change: _ => {},
});
